<template>
<!-- 设备层级关系列表 -->
<div class="table posR">
	<Loading ref="Loading"></Loading>
	<div v-if="list&&list.length" class="tableSys head bdSub-top bdSub-bottom">
		<div>{{$t('Networking18',['类型/SN'])}}</div>
		<div class="w10pct">{{$t('word166',['状态'])}}</div>
		<div class="w20pct">{{$t('word1715',['数据更新时间'])}}</div>
	</div>
	<table v-if="list">
		<tbody>
			<tr v-for="li in list" :key="li.deviceId" :class="{curP:li.childList,cMain:li.deviceId==id}" @click="ctrl($event,li)" :level="li.level" :status="li.childList?'show':null" :finalNodeStatus="!li.childList?'show':null">
				<td>
					<div class="dpIB_E vaM_E" :class="[li.levelClass]">
						<div class="w1x fs18x cSub"><span class="tra-fast" :class="{'fa fa-caret-down':li.childList&&li.childList.length}"></span></div>
						<div class="curP hover-c-main tra-fast" @click.stop="view(li)">
							<div>{{getTypeText(li.deviceName,"deviceType")}}</div>
							<div>{{li.sn}}</div>
						</div>
						<div class="borderSub bdSub-bottom"></div>
					</div>
				</td>
				<td class="w10pct">
					<div>
						<StatusIco :type="'device'" :id="li.deviceState"></StatusIco>
						<div class="borderSub bdSub-bottom"></div>
					</div>
				</td>
				<td class="w20pct">
					<div>
						{{timeFormat(li.collectionTime,"utc","%Y/%m/%d %H:%M:%S UTC",{offset:li.timeZone||timeZoneCode||stage.time.timeZoneCode})}}
						<div class="borderSub bdSub-bottom"></div>
					</div>
				</td>
			</tr>
		</tbody>
	</table>
	<!-- 
	<div v-for="li in list" :key="li.sn" class="cSub bdSub-bottom cb" :class="{curP:li.childList,cContent:li.sn==sn}" @click="ctrl($event,li)" :level="li.level" :status="li.childList?'show':null" :finalNodeStatus="!li.childList?'show':null">
		<div class="w20pct fR">{{timeFormat(li.collectionTime,"utc","%Y/%m/%d %H:%M:%S UTC",{offset:timeZoneCode||stage.time.timeZoneCode})}}</div>
		<div class="w10pct fR"><StatusIco :type="'device'" :id="li.deviceState"></StatusIco></div>
		<div class="dpIB_E vaM_E" :class="[li.levelClass]">
			<div class="w1x fs18x cSub"><span class="tra-fast" :class="{'fa fa-caret-down':li.childList}"></span></div>
			<div>
				<div>{{getTypeText(li.deviceType,"deviceType")}}</div>
				<div>{{li.sn}}</div>
			</div>
		</div>
	</div>
	 -->
	<NoData v-if="list&&list.length==0"></NoData>
</div>
</template>
<script>
import * as lib from '@/util/lib';

import NoData from '@/components/common/ui/NoResult.vue';
import Loading from '@/components/common/ui/Loading.vue';
import StatusIco from '@/components/common/ui/StatusIco.vue';

import DeviceDetail from '@/view/device/operationalAudit/ViewDetail.vue';

import {apiGetContentList,apiGetNetworkList} from '@/api/device/detail.js';
export default{
	name:"RelationshipList",
	components:{NoData,Loading,StatusIco},
	props:{
		timeZoneCode:{
			type:String,
			default:""
		},
		mode:{//展示通讯关系或组网关系,content,network
			type:String,
			default:""
		},
	},
	data(){
		return{
			stage,
			timeLock:0,//用于控制api过期
			timeKey:0,//用于核对timeLock
			// option:{
			// 	timeZoneCode:this.timeZoneCode||
			// },
			id:"",//设备id
			sn:"",//设备sn
			// type:"",//设备类型
			data:null,//api过来的原始数据
			list:null
		}
	},
	watch:{
		// list:function(data){
		// 	if(data)
		// }
	},
	methods:{
		timeFormat:lib.timeFormat,
		getTypeText:lib.getTypeText,
		show:function(snOrIdOrData,selfId){
			if($.type(snOrIdOrData)=="string" || $.type(snOrIdOrData)=="number"){//需要加载数据
				this.$refs.Loading.show();

				switch(this.mode){
					case "content"://需要传入id
						this.id=snOrIdOrData;
						// this.sn=option.sn;
						this.timeLock=this.timeKey=new Date().getTime();
						apiGetContentList(this.id).then(success=>{
							if(this.timeLock==this.timeKey){
								this.data=success;
								this.readData(this.data);
								this.$refs.Loading.hide();
								this.$emit("Loaded",{data:this.data,list:this.list});
							}
						},
						error=>{
							if(this.timeLock==this.timeKey){
								this.data=[];
								this.list=[];
								this.$refs.Loading.hide();
							}
						});
						break;
					case "network"://需要传入sn和id
						this.id=selfId;
						this.sn=snOrIdOrData;
						this.timeLock=this.timeKey=new Date().getTime();
						apiGetNetworkList(this.sn).then(success=>{
							if(this.timeLock==this.timeKey){
								this.data=success;
								this.readData(this.data);
								this.$refs.Loading.hide();

								this.$emit("Loaded",{data:this.data,list:this.list});
							}
						},
						error=>{
							if(this.timeLock==this.timeKey){
								this.data=[];
								this.list=[];
								this.$refs.Loading.hide();
							}
						});
						break;
				}
				// this.type=option.type;
			}
			else{//已有数据直接处理并呈现
				this.data=snOrIdOrData;
				this.id=selfId;
				this.readData(this.data);
				this.$refs.Loading.hide();
			}
		},
		readData:function(data){//obj拍平数据，并记录层级
			let $this=this;
			function readChild(childData,lv){
				$.each(childData,(index,val)=>{
					val.level=lv+1;
					val.levelClass="level-"+(lv+1);//level>0?"level-"+level:""
					$this.list.push(val);
					if(val.childList){
						readChild(val.childList,lv+1);
					}
				});
			}
			this.list=[];
			let level=0;//层级计算的起点
			if(!data) data=[];
			$.each(data,(index,val)=>{
				val.level=level;
				this.list.push(val);
				if(val.childList){
					readChild(val.childList,level);
				}
			});
		},
		ctrl:function(dom,device){//控制展开收起
			if(device.childList){
				let $dom=$(dom.target).parents("tr").first();
				let domList=[];
				$dom.nextUntil(`[level="${device.level}"]`).each((index,childDom)=>{
					if( Number($(childDom).attr("level"))>device.level ){
						domList.push(childDom);
					}
				});
				let status=$dom.attr("status");
				switch(status){
					case "show":
						if(domList.length>30){//防止dom过多导致卡顿
							$(domList).find("td>*").css({"display":"none"});
						}
						else{
							$(domList).find("td>*").slideUp(400,"easeInOutExpo");
						}
						$.each(domList,(index,d)=>{
							// $(d).addClass("peN").css({"border-color":"rgba(0,0,0,0)"});
							if($(d).attr("level")==String(device.level+1)){
								$(d).attr("finalNodeStatus","hide");
							}
						});
						$dom.attr("status","hide");
						break;
					case "hide":
						$.each(domList,(index,d)=>{
							if( $(d).attr("level")!=String(device.level+1)&&$(d).attr("finalNodeStatus")=="hide" ){
							}
							else{//非下一级已隐藏的不打开
								if(domList.length>30){//防止dom过多导致卡顿
									$(d).find("td>*").css({"display":""});
								}
								else{
									$(d).find("td>*").slideDown(400,"easeInOutExpo");
								}
							}
							if( $(d).attr("level")==String(device.level+1) ){//仅操作下一级
								$(d).attr("finalNodeStatus","show");
							}
							// $(d).css({"border-color":""});
						});
						$dom.attr("status","show");
						break;
				}
			}
		},
		view:function(data){
			data.activationState = data.deviceState == 0 ? 0 : 1
			this.$dynamic($(this.$el).parents("#app").find(".frame-main section").first()[0],DeviceDetail,{bg:true},{
				'closePage': [],
				'refresh': [],
				'update': [],
				'showStations': [],
				'DeviceControls': [],
				'DeviceUpgrades': [],
				'Dels': []
			},{}).then(({ instance, childInstance }) => {
				if(data.deviceId) childInstance.show(data, '', instance, data.deviceName);
				else this.$notify(getLanguageStr('device25','设备还没有数据上传记录，请确认上电并成功连接服务器后重试。'));
			});
		},
		clear:function(){
			this.timeLock=0;
			this.data=[];
			this.list=[];
			this.$refs.Loading.hide();
		}
	},
	computed:{
	},
	created(){},
	mounted(){},
	destroyed(){}
}
</script>
<style lang="scss" scoped>
@for $i from 1 through 5{
	.level-#{$i}{padding:{left:1em * $i + 1em;};}
}
[status="hide"]{
	.fa-caret-down{transform:rotate(-90deg);}
	//&+[finalNodeStatus="hide"]{border-color:rgba(#000,0);}
}
.table td{padding:{top:0;bottom:0;};position:relative;
	>*{padding:{top:1em;bottom:1em;};}
	.borderSub{width:100%;position:absolute;bottom:0;left:0;}
}

</style>


// WEBPACK FOOTER //
// src/components/common/RelationshipList.vue